import React from "react";
import { Link } from "react-router";

const Subbanner = ({ obj }) => {
  return (
    <>
      <section
        className="inner-banner bg_img"
        style={{
          background: `url(${process.env.PUBLIC_URL}/images/inner-banner/bg2.jpg) top`,
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-xl-6 text-center">
              <h2 className="title text-white">{obj.title}</h2>
              <ul className="breadcrumbs d-flex flex-wrap align-items-center justify-content-center">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>{obj.page}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Subbanner;
